module.exports = __webpack_public_path__ + "static/img/8.34e5061.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/zh/8.png
// module id = D26n
// module chunks = 0